import { dateParamType } from '~/utils/gcxDates/toDate'

type removeTZFromDateType = (date: dateParamType) => Date

/**
 * @description used when we want to have the date value only
 * @param '2020-10-12'
 * @returns a date without the TZ difference
 */

export const removeTZFromDate: removeTZFromDateType = (dateProp) => {
  dateProp = new Date(dateProp)
  const date = new Date(
    dateProp.valueOf() + dateProp.getTimezoneOffset() * 60 * 1000,
  )

  return date
}
